// extracted by mini-css-extract-plugin
export default {"events":"EventsList_events__uOmCp","list":"EventsList_list__JZR9U","item":"EventsList_item__ZYJDe","event":"EventsList_event__M2K+W"};